import { atom } from 'recoil';

export const loginBannerErrorState = atom({
  key: 'loginBannerErrorState',
  default: ''
});

export const userConfigState = atom({
  key: 'userConfigState',
  default: {
    isPostLogin: false,
    isSingnetUser: false,
    isEmailVerify: false,
    userFlow: '',
    contact: '',
  }
});

// Channel IDs that support NRIC reset password flow
const nricResetPswdFlowIds = [
  '131c893b-3817-408e-9628-45debdea4fbd', // onepass-web
  // '55552aa5-3449-41f7-a0cb-5444f7959850', // Shirley-chatbot
  'f0e01c37-233f-4457-90d9-f94daeadd517' // SPRINGD
];

export const shouldShowNricResetPswdFlow = (flowConfig: object): boolean => {
  if (!flowConfig) {
    return false;
  }
  return nricResetPswdFlowIds.includes(flowConfig?.flowId);
};
